// @ts-nocheck
import chroma from 'chroma-js';
import { css } from '@emotion/css';

const tenantTheme = (mainColor = '') => {
  const darkenColor = chroma(mainColor).darken(0.5).hex();
  const lightenColor = chroma(mainColor).alpha(0.1).hex();
  return css`
    .lighten-background {
      background-color: ${lightenColor} !important;
    }
    .ant-menu-title-content {
      color: #2E2B2B;
    }
    .talent-sup__back-button {
      cursor: pointer;
    }
    .ant-descriptions-item .ant-descriptions-item-label, a {
      color: ${mainColor} !important;
    }
    a:hover, .talent-sup__back-button:hover {
      color: ${darkenColor} !important;
    }
    .path-main-color path {
      fill: ${mainColor} !important;
    }
    .ant-menu-item-selected .ant-menu-item-icon path, .ant-menu-item:hover .ant-menu-item-icon path {
        fill: ${mainColor};
    }
    .ant-menu-item-selected .ant-menu-title-content, ant-menu-submenu-active span.ant-menu-title-content, .ant-menu-item-active span.ant-menu-title-content, .ant-menu-item:hover .ant-menu-title-content {
      color: ${mainColor} !important;
    }
    .ant-menu-item:hover .ant-menu-item-icon svg path {
      fill: ${mainColor} !important;
    }
    .ant-menu-item-selected .ant-menu-title-content::after, .ant-menu-submenu span.ant-menu-title-content::after, .ant-menu-item-active span.ant-menu-title-content::after {
      background-color: ${mainColor};
    }
    .ant-input-search .ant-input:hover, .ant-input-search .ant-input:focus {
      border-color: ${mainColor};
    }
    .ant-menu-submenu:hover ant-menu-submenu-title span.ant-menu-title-content {
      color: ${mainColor};
    }
    .ant-badge-count {
      background: ${mainColor};
    }
    .ant-menu-submenu-title:hover svg path {
      fill: ${mainColor};
    }
    .ant-input:focus, .ant-input-focused {
      box-shadow: 0 0 0 2px ${chroma(mainColor).alpha(0.2).hex()};
    }
    .tenant-color, .main-color {
      color: ${mainColor};
    }
    .tenant-border {
      border-color: ${mainColor} !important;
    }
    .ant-table-thead > tr > th {
      color: ${mainColor} !important;
    }
    .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
      color: ${mainColor};
    }
    .ant-btn-compact-item.ant-btn-primary:not([disabled]) + .ant-btn-compact-item.ant-btn-primary:not([disabled])::after {
      background-color: ${darkenColor} !important;
    }
    .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-expand-icon, .ant-menu-submenu:hover > .ant-menu-submenu-title > .ant-menu-submenu-arrow, .ant-menu-submenu-title:hover span.ant-menu-title-content {
      color: ${mainColor} !important;
    }
    .ant-tabs-tab:hover {
      color: ${darkenColor} !important;
    }
    .ant-tabs-ink-bar {
      background-color: ${mainColor};
    }
    .ant-btn:not(.ant-btn-dangerous):not(.ant-btn-primary) {
      color: ${mainColor};
      border-color: ${mainColor};
    }
    .ant-btn:not(.ant-btn-dangerous):not(.ant-btn-primary):hover {
      color: ${darkenColor};
      border-color: ${darkenColor};
    }
    .ant-btn-primary {
      background-color: ${mainColor};
      border-color: ${mainColor};
    }
    .ant-btn-primary:hover {
      background-color: ${darkenColor};
      border-color: ${darkenColor};
    }
    .ant-checkbox-checked::after {
      border-color: ${mainColor} !important;
    }
    .ant-input:hover, .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
      border-color: ${mainColor};
    }
    .ant-checkbox-checked .ant-checkbox-inner {
      border-color: ${mainColor};
      background-color: ${mainColor};
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) .lighten-background {
      background-color: ${lightenColor} !important;
    }
    .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
      box-shadow: 0 0 0 2px ${lightenColor} !important;
      border-color: ${mainColor};
    }
    .ant-select-item-option-selected:not(.ant-select-item-option-disabled) {
      background-color: ${lightenColor};
    }
    .ant-pagination-item a {
      color: #D9D9D9 !important;
    }
    .ant-pagination-item.ant-pagination-item-active a, .ant-pagination-item:hover a {
      color: ${mainColor} !important;
    }
    .text-black {
      color: #2E2B2B !important;
    }
    .ant-radio-checked .ant-radio-inner {
      border-color: ${mainColor} !important;
    }
    .ant-radio-inner::after {
      background-color: ${mainColor} !important;
    }
    .ant-checkbox-wrapper:hover .ant-checkbox-inner, .ant-checkbox:hover .ant-checkbox-inner, .ant-checkbox-input:focus + .ant-checkbox-inner, .ant-radio-wrapper:hover .ant-radio, .ant-radio:hover .ant-radio-inner, .ant-radio-input:focus + .ant-radio-inner {
      border-color: ${mainColor} !important;
    }
    .ant-radio-checked::after {
      border-color: ${mainColor} !important;
      background-color: ${mainColor} !important;
    }
    .ant-slider-track, .ant-slider:hover .ant-slider-track {
      background-color: ${mainColor};
    }
    .ant-slider-handle:focus {
      box-shadow: 0 0 0 5px ${lightenColor};
    }
    .ant-slider-handle.ant-tooltip-open {
      border-color: ${mainColor};
    }
    .ant-menu-light .ant-menu-submenu-title:hover {
      color: ${mainColor};
    }
    .ant-menu-submenu-active span.ant-menu-title-content {
      color: ${mainColor};
    }
    .talentsup-react-select__control--is-focused {
      border-color: ${mainColor} !important;
      border-width: 1px !important;
      box-shadow: 0 0 0 2px ${lightenColor} !important;
    }
    .talentsup-react-select__option--is-focused {
      background-color: #F5F5F5;
    }
    .layout-footer {
      background-color: ${mainColor};
    }
    .ant-progress-bg, .progress-bar-inner {
      background-color: ${mainColor} !important;
    }
  `;
};

export default tenantTheme;
